export default "__VITE_ASSET__CvfAdXsq__"